import { useNavigate } from "react-router-dom";
import Paths from "../../../paths";
import { ReactComponent as AlertIcon } from "./../../../assets/Icons_Alert.svg";
import { UnauthorizedLayout, UnauthorizedContainer } from "./unauthorizedStyled";
import { LoginButton } from "../../../style/layouts";

export default function Unauthorized() {
  const history = useNavigate();

  const login = () => {
    history(Paths.Login);
  };

  return (
    <UnauthorizedContainer>
      <UnauthorizedLayout>
        <h1> You are unauthorized to access the application. Please try again.</h1>
        <AlertIcon title="AlertIcon"></AlertIcon>
        <LoginButton onClick={() => login()}>Login</LoginButton>
      </UnauthorizedLayout>
    </UnauthorizedContainer>
  );
}
